export default {
  created() {
    if (this.$cookies.get('search-query-id')) {
      this.$store.commit('listingPageSearch/setSearchQueryId', {
        value: this.$cookies.get('search-query-id'),
        path: this.$route.path
      })

      this.$cookies.remove('search-query-id', {
        path: this.$route.path
      })
    } else {
      const searchQueryIdPath =
        this.$store.getters['listingPageSearch/searchQueryId'].path

      if (
        searchQueryIdPath &&
        !this.$route.path.startsWith(searchQueryIdPath)
      ) {
        this.$store.commit('listingPageSearch/setSearchQueryId', {})
      }
    }
  }
}
